var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgList(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 4,
    height: 5,
    viewBox: "0 0 4 5",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.98413 4.376C1.62146 4.376 1.29079 4.29067 0.992125 4.12C0.693458 3.93867 0.453458 3.69867 0.272125 3.4C0.101458 3.10133 0.016125 2.77067 0.016125 2.408C0.016125 2.04533 0.101458 1.71467 0.272125 1.416C0.453458 1.11733 0.693458 0.877333 0.992125 0.696C1.29079 0.514666 1.62146 0.424 1.98413 0.424C2.35746 0.424 2.69346 0.514666 2.99213 0.696C3.29079 0.877333 3.52546 1.11733 3.69613 1.416C3.87746 1.71467 3.96813 2.04533 3.96813 2.408C3.96813 2.77067 3.87746 3.10133 3.69613 3.4C3.52546 3.69867 3.29079 3.93867 2.99213 4.12C2.69346 4.29067 2.35746 4.376 1.98413 4.376Z",
    fill: "#026735"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgList);
export default __webpack_public_path__ + "static/media/list.1c67275f060779bdb480a0f1617cac84.svg";
export { ForwardRef as ReactComponent };